const getDefaultState = () => {
  return {
    test: "changedit",
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  CHANGE_VALUE(state, newValue) {
    state.test = newValue;
  }
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  changeValue({commit}, newValue){
    commit("CHANGE_VALUE", newValue);
  }
};

const survey = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default survey;
